module.exports = __webpack_public_path__ + "media/images/emblems/Val_Muestair_(Kreis)_wappen-26b92ada75b10a4214fd0b715455eef1.svg";